// Service to replace native alert() with custom alerts
let alertInstance = null;

export const setAlertInstance = (instance) => {
    alertInstance = instance;
};

export const customAlert = (message, type = 'info', title = '') => {
    if (alertInstance) {
        switch (type) {
            case 'success':
                return alertInstance.showSuccess(message, title || 'Success');
            case 'error':
                return alertInstance.showError(message, title || 'Error');
            case 'warning':
                return alertInstance.showWarning(message, title || 'Warning');
            case 'info':
            default:
                return alertInstance.showInfo(message, title || 'Information');
        }
    } else {
        // Fallback to native alert if service not initialized
        return window.alert(message);
    }
};

// Override native alert globally (optional)
export const overrideNativeAlert = () => {
    window.alert = customAlert;
};

export default customAlert;